import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import R from 'ramda';
import A from 'aphrodite';
import querystring from 'query-string';

import List from './list/listContainer';
import LeftNav from './left-nav/left-nav';
import TopBar from './top-bar/top-bar';
import SendContract from 'material-ui/svg-icons/content/send';
import { Paper, RaisedButton, ListItem, FontIcon, Divider, IconButton } from 'material-ui';
import InfoIcon from 'material-ui/svg-icons/action/info';
import Pagination from '../../tc-ui/pagination/pagination';
import FreeContractForContractorDialog from './free-contract-contractor-dialog';
import ResendContractDialog from '../contract-activities-products/contract-container/dialogs/resend-or-update-dialog';
import PublishDraftDialog from '../contract-activities-products/draftNTemplate-container/publish-draft-dialog';
import BulkResendDialog from './bulk-resend-dialog';
import CreateFolderAndAssignContracts from './manage-folder-dialog';
import DropdownMenu from '../../tc-ui/flatDropDownMenu';
import { push as pushAction } from 'react-router-redux';


import {
  getContractList as getContractListAction,
  getContractFolders as getContractFoldersAction,
  changeRoute as changeRouteAction,
  updateProps as updatePropsAction,
  updateSearchParams as updateSearchParamsAction,
  resetSearchParams as resetSearchParamsAction,
  selectAContract as selectAContractAction,
  openResendContractDialog as openResendContractDialogAction,
  manageFolders as manageFoldersAction,
  moveToTrashOrRestore as moveToTrashOrRestoreAction,
  moveToArchiveOrRestore as moveToArchiveOrRestoreAction,
  deleteFolder as deleteFolderAction,
  saveNewFolder as saveNewFolderAction,
  updateFolders as updateFoldersAction,
  selectCurrentAll as selectCurrentAllAction,
  stateChange as stateChangeAction,
  openBulkResendDialog as openBulkResendDialogAction,
  markAsViewed,
  showFreeContractDialogAction,
  downloadContractPdf,
} from '../../../stores/contracting/contract-list/contract-list-actions';
import docCookies from '../../../utils/docCookie';

const propTypes = {
  params: PropTypes.object,
  getContractList: PropTypes.func,
  getContractFolders: PropTypes.func,
  changeRoute: PropTypes.func,
  location: PropTypes.object,
  list: PropTypes.object,
  searchInput: PropTypes.string,
  updateProps: PropTypes.func,
  showFreeContractDialog: PropTypes.func,
  billingPlan: PropTypes.string,
  resourceType: PropTypes.string,
  freeContractsUsedIds: PropTypes.array,
  unselectAllContracts: PropTypes.func,
  manageFolders: PropTypes.func,
  actionsForContract: PropTypes.object,
  previousSearchParams: PropTypes.object,
  bulkActions: PropTypes.object,
  searchParams: PropTypes.object,
  deleteFolder: PropTypes.func,
  saveNewFolder: PropTypes.func,
  updateFolders: PropTypes.func,
  selectCurrentAll: PropTypes.func,
  isTourReady: PropTypes.bool,
  user: PropTypes.object,
  dispatch: PropTypes.func,
  isAnAdmin: PropTypes.bool,
  push: PropTypes.func,
  updateSearchParams: PropTypes.func,
  resetSearchParams: PropTypes.func,
  currentYear: PropTypes.object,
  startPolling: PropTypes.bool,
  pathBeforeSearch: PropTypes.string,
  inWhere: PropTypes.string,
  keepOldUI: PropTypes.func,
};
// const periodNotEqual = (objA = {}, objB = {}) => objA.startDate !== objB.startDate || objA.endDate !== objB.endDate;
class ContractListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      manageFolderDialogOpen: false,
      leftNavOpen: true,
    };
  }
  componentDidMount() {
    document.title = window.location.pathname.indexOf('contract-list') > 1 ? `Contract List` : 'Workspace';
    if (this.props.inWhere !== 'workspace') {
      this.populateSearchParamsFromLocationQuery();
    }
    const { getContractFolders } = this.props;
    getContractFolders();
  }

  componentWillReceiveProps(nextProps) {
    const _this = this;
    const { startPolling } = _this.props;
    if (!R.equals(startPolling, nextProps.startPolling) && this.props.inWhere !== 'workspace') {
      clearTimeout(_this.timeout);
      if (!nextProps.startPolling) _this.startPoll();
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  componentDidUpdate() {
    localStorage.setItem('lastContractListHref', window.location.href);
  }
  componentWillUnmount() {
    clearTimeout(this.timeout);
  }
  getQuery = (query = {}) => {
    const { list, searchParams, currentYear } = this.props;
    return {
      listType: (this.props.params.type || this.props.searchParams.searchCategory || 'recent'),
      page: list.page || 1,
      currentYear,
      ...searchParams,
      ...query,
    };
  };
  populateSearchParamsFromLocationQuery = () => {
    const { location, list, updateSearchParams, params, updateProps, getContractList } = this.props;
    const { isFolder } = location.query;
    updateProps({
      isFolder: isFolder === 'true',
      list: {
        ...list,
        listType: params.type,
      },
    });
    if (params.type === 'search') {
      const searchParamsToBeUpdated = R.mapObjIndexed((val, key) => {
        if (R.contains('Filter', key) && R.is(String, val)) return [val];
        if (
          key === 'newActivity'
          || key === 'isFolder'
          || key === 'openAdvanceSearch'
          || key === 'searchingAllYears'
          || key === 'showRateContainers'
          || key === 'showArchivedDeleted'
        ) {
          return val === 'true';
        }
        if (key === 'sortRule' && val) return parseInt(val, 10);
        if (key === 'ids' && val && R.is(String, val)) {
          return JSON.parse(val);
        }
        return val;
      }, location.query);
      // this will trigger a API call for getting contracts after params are updated
      updateSearchParams(searchParamsToBeUpdated);
    } else {
      getContractList();
    }
  };
  startPoll = () => {
    // If user is searching, no need to keep fetching data
    this.timeout = setTimeout(() => {
      if (this.props.list.listType !== 'search') {
        this.props.getContractList(true);
      }
    }, 60e3);
  };

  loadMore = (page) => {
    const { updateSearchParams } = this.props;
    updateSearchParams({ page });
  };
  search = (searchParams) => {
    const { updateProps, list, updateSearchParams } = this.props;
    this.props.push({
      pathname: `/contracting/contract-list/search`,
      query: R.call(R.compose(
        R.pick(R.keys(searchParams)), // remove null KV
        R.omit(['canBulkResend', 'canBulkAccept', 'canBulkReceive', 'currentYear']),
        R.mapObjIndexed((val) => {
          if (val) return val;
        })
      ), searchParams),
    });
    updateProps({
      list: R.merge(list, { listType: 'search' }),
      pathBeforeSearch: this.props.pathBeforeSearch || this.props.list.listType,
    });
    updateSearchParams(searchParams);
  };
  goTo = R.curry((activiesOrDetails, collection, contractId) => {
    const { resourceType, location, isAnAdmin } = this.props;
    if (this.props.inWhere !== 'workspace') {
      const { pathname, query } = location;
      docCookies.setItem('pathname', pathname);
      if (querystring.stringify(query)) docCookies.setItem('query', querystring.stringify(query));
    }
    const goToFunc = id => this.props.push(`/contracting/${collection}/${id}/${activiesOrDetails}`);
    if (resourceType === 'Contractor' && !isAnAdmin && activiesOrDetails === 'details') {
      markAsViewed(contractId);
    }
    return goToFunc(contractId);
  });
  goToSupplierWizard = id => {
    if (!this.props.isAnAdmin) markAsViewed(id);
    this.props.push(`/contracting/supplier-wizard/${id}`);
  };

  createContract = () => {
    window.dataLayer.push({
      event: 'TRACK_EVENT',
      ev: {
        category: 'Contract List Click',
        action: '/partner-management/create-workspace',
      },
    });
    if (this.props.resourceType === 'Supplier') {
      window.location = (`${
        process.env.NEW_SYSTEM_URL
      }/partner-management/send-assets?go_back_to=${window.location.href}&jwt=${
        localStorage.getItem('jwt')
      }&open_asset_type=rates`);
    } else {
      window.location = (`${
        process.env.NEW_SYSTEM_URL
      }/partner-management/create-workspace?go_back_to=${window.location.href}&jwt=${
        localStorage.getItem('jwt')
      }&sendRequest=yes`);
    }
  };

  requestRC = slug => () => {
    window.dataLayer.push({
      event: 'TRACK_EVENT',
      ev: {
        category: 'Contract List Click',
        action: `/partner-management/create-rc-container?rateConversionParty=${slug}`,
      },
    });
    window.location = (`${
      process.env.NEW_SYSTEM_URL
    }/partner-management/create-rc-container?rateConversionParty=${slug}&go_back_to=${window.location.href}&jwt=${
      localStorage.getItem('jwt')
    }`);
  };

  openHelp = url => e => {
    e.stopPropagation();
    window.open(url);
  };
  render() {
    const styles = A.StyleSheet.create({
      NavAndList: { display: 'flex', alignItems: 'stretch' },
      list: { width: this.state.leftNavOpen ? '80%' : '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' },
    });
    const {
      updateProps,
      bulkActions,
      manageFolders,
      actionsForContract,
      list,
      updateSearchParams,
      deleteFolder,
      saveNewFolder,
      updateFolders,
      selectCurrentAll,
      resourceType,
      inWhere,
    } = this.props;
    if (inWhere === 'workspace') {
      return (
        <div>
          <List
            className="contractListContainer"
            selectCurrentAll={() => selectCurrentAll(this.getQuery())}
            unselectAll={bulkActions.unselectAll}
            showFolder
            updateSearchParams={updateSearchParams}
            actionsForContract={R.merge({
              updateProps,
              viewContract: this.goTo('details'),
              viewActivities: this.goTo('activities'),
              viewNotes: this.goTo('notes'),
              goToSupplierWizard: this.goToSupplierWizard,
            }, actionsForContract)}
          />
          {/* { list.totalPages > 1 ? <Pagination style={{ backgroundColor: '#fafafa' }} currentPage={list.page} totalPages={list.totalPages} goToPage={this.loadMore} noOfPagesToShow={7}/> : <span/> } */}
          <FreeContractForContractorDialog/>
          <ResendContractDialog/>
          <PublishDraftDialog/>
          <BulkResendDialog/>
          <CreateFolderAndAssignContracts
            createFolderAndAssign={manageFolders}
            updateProps={updateProps}
          />
        </div>
      );
    }
    return (
      <div>
        <Paper style={{ marginBottom: '64px' }} zDepth={1}>
          <div className={A.css(styles.NavAndList)}>
            <div
              style={{ display: 'flex', flexDirection: 'column', width: '20%', minWidth: '250px' }}
            >
              <div style={{ backgroundColor: 'rgba(0, 0, 0, 0.1)', color: 'white', fontSize: '18px', height: '48px', minHeight: '48px', textAlign: 'center' }}>
                {
                  resourceType === 'Supplier' ? (
                  <RaisedButton
                    id="appBarContractsButton"
                    primary
                    style={{ marginTop: '6px', minWidth: '250px' }}
                    onTouchTap={this.createContract}
                    labelStyle={{ top: '-1.5px' }}
                    label={resourceType === 'Supplier' ? 'Send Contracts' : 'Send Contract Requests'}
                    icon={<SendContract style={{ position: 'relative', top: '-1.5px' }} />}
                  />
                  ) : (
                    <DropdownMenu
                      button={<RaisedButton
                        primary
                        label="New Contract"
                        style={{ marginTop: '6px', minWidth: '250px' }}
                        icon={<FontIcon className="tc-icon-add" />}
                      />}
                      useList
                      menuProps={{
                        style: { width: '320px' },
                      }}
                    >
                    <ListItem
                      primaryText="Send a Supplier Rate Request"
                      onClick={this.createContract}
                      rightIconButton={
                        <IconButton
                          onClick={this.openHelp('http://support.tourconnect.com/en/articles/4446790-send-a-supplier-rate-request')}
                        >
                          <InfoIcon color="#9e9e9e"/>
                        </IconButton>}
                    />
                    <Divider/>
                    <ListItem
                      primaryText="Upload/Convert Myself"
                      onClick={this.requestRC('buyer')}
                      rightIconButton={
                        <IconButton
                          onClick={this.openHelp('http://support.tourconnect.com/en/articles/4446791-upload-convert-myself')}
                        >
                          <InfoIcon color="#9e9e9e"/>
                        </IconButton>}
                    />
                    {/* <Divider/>
                    <ListItem
                      primaryText="Request Rate Conversion"
                      onClick={this.requestRC('DL')}
                      rightIconButton={
                        <IconButton
                          onClick={this.openHelp('http://support.tourconnect.com/en/articles/4446795-request-rate-conversion')}
                        >
                          <InfoIcon color="#9e9e9e"/>
                        </IconButton>}
                    /> */}
                  </DropdownMenu>
                  )
                }
              </div>
              <LeftNav
                routeName={(this.props.params.type || this.props.searchParams.searchCategory || 'recent')}
                changeRoute={this.props.changeRoute}
                updateProps={updateProps}
                deleteFolder={deleteFolder}
                saveNewFolder={saveNewFolder}
                updateFolders={updateFolders}
              />
            </div>
            <div className={A.css(styles.list)}>
              <div>
                <TopBar
                  routeName={(this.props.params.type || this.props.searchParams.searchCategory || 'recent')}
                  toggleMenu={() => this.setState({ leftNavOpen: !this.state.leftNavOpen })}
                  createContract={this.createContract}
                  updateProps={updateProps}
                  {...bulkActions}
                  forFiltersAndSearch={{
                    updateSearchParams,
                    updateSearchInput: (k, v) => updateProps({ [k]: v }),
                    search: this.search,
                    changeRoute: this.props.changeRoute,
                  }}
                />
                <List
                  className="contractListContainer"
                  selectCurrentAll={() => selectCurrentAll(this.getQuery())}
                  unselectAll={bulkActions.unselectAll}
                  showFolder
                  updateSearchParams={updateSearchParams}
                  actionsForContract={R.merge({
                    updateProps,
                    viewContract: this.goTo('details'),
                    viewActivities: this.goTo('activities'),
                    viewNotes: this.goTo('notes'),
                    goToSupplierWizard: this.goToSupplierWizard,
                  }, actionsForContract)}
                />
              </div>
              { list.totalPages > 1 ? <Pagination style={{ backgroundColor: '#fafafa' }} currentPage={list.page} totalPages={list.totalPages} goToPage={this.loadMore} noOfPagesToShow={7}/> : <span/> }
            </div>
          </div>
        </Paper>
        <FreeContractForContractorDialog/>
        <ResendContractDialog/>
        <PublishDraftDialog/>
        <BulkResendDialog/>
        <CreateFolderAndAssignContracts
          createFolderAndAssign={manageFolders}
          updateProps={updateProps}
        />
      </div>
    );
  }
}
ContractListContainer.propTypes = propTypes;
const mapStateToProps = ({ contracting, user }) => ({
  currentYear: contracting.currentYear,
  list: contracting.contractList.get('list').toJS(),
  pathBeforeSearch: contracting.contractList.get('pathBeforeSearch'),
  startPolling: contracting.contractList.get('startPolling'),
  searchParams: contracting.contractList.get('searchParams').toJS(),
  previousSearchParams: contracting.contractList.get('previousSearchParams') ? contracting.contractList.get('previousSearchParams').toJS() : {},
  resourceType: user.getIn(['user', 'type']),
  freeContractsUsedIds: user.get('freeContractsUsedIds'),
  billingPlan: user.get('billingPlan'),
  isAnAdmin: user.get('isAnAdmin'),
});

const mapDispatchedToActions = dispatch => ({
  getContractList: (...args) => dispatch(getContractListAction(...args)),
  getContractFolders: (...args) => dispatch(getContractFoldersAction(...args)),
  changeRoute: (...args) => dispatch(changeRouteAction(...args)),
  updateProps: (...args) => dispatch(updatePropsAction(...args)),
  updateSearchParams: (...args) => dispatch(updateSearchParamsAction(...args)),
  resetSearchParams: () => dispatch(resetSearchParamsAction()),
  showFreeContractDialog: R.curry((activiesOrDetails, contractId) => dispatch(showFreeContractDialogAction(activiesOrDetails, contractId))),
  deleteFolder: (...args) => dispatch(deleteFolderAction(...args)),
  saveNewFolder: (...args) => dispatch(saveNewFolderAction(...args)),
  updateFolders: (...args) => dispatch(updateFoldersAction(...args)),
  selectCurrentAll: (...args) => dispatch(selectCurrentAllAction(...args)),
  bulkActions: {
    unselectAll: () => dispatch(updatePropsAction({ selectedContracts: [], allContractIds: [] })),
    moveAllToTrash: contractIds => dispatch(moveToTrashOrRestoreAction(true, contractIds)),
    restoreAll: contractIds => dispatch(moveToTrashOrRestoreAction(false, contractIds)),
    moveAllToArchived: contractIds => dispatch(moveToArchiveOrRestoreAction(true, contractIds)),
    restoreAllFromArchived: contractIds => dispatch(moveToArchiveOrRestoreAction(false, contractIds)),
    stateChange: R.curry((contractIds, newStatus) => dispatch(stateChangeAction(contractIds, newStatus))),
    openBulkResendDialog: (...args) => dispatch(openBulkResendDialogAction(...args)),
  },
  manageFolders: (...args) => dispatch(manageFoldersAction(...args)),
  actionsForContract: {
    moveToTrash: contractId => dispatch(moveToTrashOrRestoreAction(true, [contractId])),
    restoreContract: contractId => dispatch(moveToTrashOrRestoreAction(false, [contractId])),
    moveToArchived: contractId => dispatch(moveToArchiveOrRestoreAction(true, [contractId])),
    restoreContractFromArchived: contractId => dispatch(moveToArchiveOrRestoreAction(false, [contractId])),
    selectAContract: (...args) => dispatch(selectAContractAction(...args)),
    openResendContractDialog: (...args) => dispatch(openResendContractDialogAction(...args)),
    stateChange: (contractId, newStatus) => dispatch(stateChangeAction([contractId], newStatus)),
    downloadContractPdf: (...args) => dispatch(downloadContractPdf(...args)),
  },
  push: (...args) => dispatch(pushAction(...args)),
});
ContractListContainer.contextTypes = {
  router: React.PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchedToActions)(ContractListContainer);



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-list/contract-list-container.jsx